import { PageNotFoundComponent } from './components/page-not-found/page-not-found.component';
import { PublicApiService } from './services/public-api.service';
import { SharedModule } from '../shared/shared.module';
import { NgModule, Optional, SkipSelf } from '@angular/core';
import { PplButtonModule } from '@ppl/ui/button';
import { PplIconModule, PplIconService } from '@ppl/ui/icon';
import { PplTopBarModule } from '@ppl/ui/top-bar';

@NgModule({
  imports: [
    PplTopBarModule,
    PplButtonModule,
    PplIconModule,
    SharedModule
  ],
  declarations: [
    PageNotFoundComponent
  ],
  exports: [
  ],
  providers: [
    PublicApiService,
    PplIconService
  ]
})
export class CoreModule {
  constructor(
    @Optional()
    @SkipSelf()
    parentModule: CoreModule
  ) {
    if (parentModule) {
      throw new Error('CoreModule is already loaded. Import it in the AppModule only');
    }
  }
}
